import { Modal } from "react-bootstrap";
import propTypes from "prop-types";

const IdProofUploadModal = ({
  show,
  onHide,
  onUploadFromBrowser,
  onUploadFromDigiLocker,
  loading = false,
}) => {
  const handleBrowserClick = () => {
    onUploadFromBrowser?.();
    onHide();
  };

  const handleDigiLockerClick = () => {
    onUploadFromDigiLocker?.();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "0.95rem" }}>
          Select Upload Option
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex flex-column gap-3">
          

          <button
            className="btn btn-outline-primary custombg"
            onClick={handleDigiLockerClick}
            style={{ fontSize: "0.875rem" }}
            disabled={loading}
          >
            Upload from DigiLocker
          </button>
          <button
            className="btn btn-outline-primary custombg"
            onClick={handleBrowserClick}
            style={{ fontSize: "0.875rem" }}
            disabled={loading}
          >
            Upload from Device
          </button>
		  <div
            className="text-muted"
            style={{
              fontSize: "0.8rem",
              lineHeight: "1.4",
              backgroundColor: "#f7f9fc",
              padding: "10px 12px",
              borderRadius: "6px",
              border: "1px solid #e5e7eb",
            }}
          >
          <strong>Note:</strong>  We recommend using DigiLocker for secure and verified document
            retrieval. You may also upload documents manually from your device.
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

IdProofUploadModal.propTypes = {
  show: propTypes.bool.isRequired,
  onHide: propTypes.func.isRequired,
  onUploadFromBrowser: propTypes.func,
  onUploadFromDigiLocker: propTypes.func,
  loading: propTypes.bool,
};

export default IdProofUploadModal;
